import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fbcdd04"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Grupo", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Lojas", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Regiões", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Automações", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { role: "status" }, "Carregando...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_FilterBase = _resolveComponent("FilterBase")!

  return (_openBlock(), _createBlock(_component_FilterBase, {
    id: "dashboard",
    subtitle: "Faça filtros e aprimore sua busca",
    hideFilter: false,
    staticModal: false,
    hideClose: false,
    activeModal: false,
    closeModal: _ctx.closeModal,
    disabledClick: true,
    onSearch: _cache[4] || (_cache[4] = ($event: any) => (_ctx.enviarEmit()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_el_select, {
          modelValue: _ctx.storeFilter.grupo,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.storeFilter.grupo) = $event)),
          filterable: "",
          "collapse-tags": "",
          placeholder: "Selecione um grupo",
          clearable: "",
          class: "w-100 mb-4"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeGroups, (group, key) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: group.nome,
                value: group.id,
                key: key
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(group.nome), 1)
                ]),
                _: 2
              }, 1032, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _hoisted_2,
        _createVNode(_component_el_select, {
          "collapse-tags": "",
          filterable: "",
          placeholder: _ctx.loadingLojas ? 'Carregando lojas...' : 'Selecione...',
          clearable: "",
          multiple: "",
          modelValue: _ctx.storeFilter.loja,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.storeFilter.loja) = $event)),
          disabled: !_ctx.storeFilter.grupo || _ctx.loadingLojas,
          class: "w-100 mb-4"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lojas, (loja, key) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: key,
                label: loja.nome,
                value: loja.codConcessionaria
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["placeholder", "modelValue", "disabled"]),
        _hoisted_3,
        _createVNode(_component_el_select, {
          "collapse-tags": "",
          filterable: "",
          placeholder: "Selecione...",
          clearable: "",
          multiple: "",
          modelValue: _ctx.storeFilter.regiao,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.storeFilter.regiao) = $event)),
          class: "w-100 mb-4"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regioes, (regiao, key) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: key,
                label: regiao,
                value: regiao
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _hoisted_4,
        _createVNode(_component_el_select, {
          class: "w-100",
          filterable: "",
          "collapse-tags": "",
          multiple: "",
          "value-key": "id",
          placeholder: "Selecione...",
          modelValue: _ctx.storeFilter.idErps,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.storeFilter.idErps) = $event)),
          clearable: ""
        }, {
          default: _withCtx(() => [
            (_ctx.loadErps)
              ? (_openBlock(), _createBlock(_component_el_option, {
                  key: 0,
                  value: "",
                  class: "d-flex align-items-center gap-2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _hoisted_6
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayErps, (erp) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: erp.id,
                value: erp.id,
                label: erp.nome
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["closeModal"]))
}